

export const dedup = <T>(previousValue: T[], currentValue: T) => {
  if (!previousValue.includes(currentValue)) {
    previousValue.push(currentValue);
  }
  return previousValue;
}

export const makeDeduper = <T>(comparer: (a: T, b: T) => boolean) => {
  return (previousValue: T[], currentValue: T) => {
    if (!previousValue.find((v) => comparer(v, currentValue))) {
      previousValue.push(currentValue);
    }
    return previousValue;
  }
}